<template>
    <Teleport to="body">
        <transition name="fade">
            <div v-if="versionInfo" class="nc-version-banner">
                <i class="mdi mdi-update"></i>
                <span>
                    {{ $t('Version {version} is available.', { version: versionInfo.version }) }}
                    <template v-if="versionInfo.message">— {{ versionInfo.message }}</template>
                </span>
                <a @click.prevent="reloadPage" class="nc-version-link">{{ $t('Refresh now') }}</a>
                <button class="nc-version-close" @click="versionInfo = null">
                    <i class="mdi mdi-close"></i>
                </button>
            </div>
        </transition>
    </Teleport>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const versionInfo = ref(null);

onMounted(async () => {
    const Echo = await window.initEcho();
    Echo.channel('version').listen('.NewVersionAvailable', e => {
        versionInfo.value = { version: e.version, message: e.message };
    });
});

function reloadPage() {
    window.location.reload();
}
</script>

<style scoped>
.nc-version-banner {
    position: fixed;
    top: 52px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    display: flex;
    align-items: center;
    gap: 8px;
    background: var(--bulma-warning-light);
    border: 1px solid var(--bulma-warning);
    border-radius: 8px;
    padding: 8px 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    font-size: 0.85rem;
    color: var(--bulma-text-strong);
    white-space: nowrap;
}
.nc-version-banner .mdi-update {
    color: var(--bulma-warning);
    font-size: 1.1rem;
}
.nc-version-link {
    font-weight: 600;
    margin-left: 4px;
}
.nc-version-close {
    background: none;
    border: none;
    color: var(--bulma-text-weak);
    cursor: pointer;
    padding: 0 2px;
    margin-left: 4px;
    font-size: 0.9rem;
    line-height: 1;
}
.nc-version-close:hover {
    color: var(--bulma-text-strong);
}
</style>
